import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Sparkles } from "lucide-react";

export const PrivateBetaBanner = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings(null));
  }, []);

  if (!settings || !settings.private_beta) return null;

  return (
    <div className="bg-foreground text-white" data-testid="private-beta-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-start sm:items-center gap-2.5 text-xs sm:text-sm">
        <Sparkles className="h-4 w-4 text-accent shrink-0 mt-0.5 sm:mt-0" />
        <p className="leading-snug">
          <span className="font-semibold text-accent uppercase tracking-wider mr-2">Private Beta</span>
          {settings.beta_notice}
          {" "}
          <Link to="/register" className="underline underline-offset-2 hover:text-accent whitespace-nowrap" data-testid="beta-banner-register">Request beta access</Link>
        </p>
      </div>
    </div>
  );
};
